/**
 * commitURL links a commit to its repository host (CO-100, the audit's
 * "deployment → commit" gap): GitHub, GitLab and Bitbucket, from an https
 * or git@ remote. Any other host gets no link rather than a guessed one.
 */
export function commitURL(repositoryUrl: string | undefined | null, sha: string): string | undefined {
  if (!repositoryUrl || !/^[0-9a-f]{7,40}$/i.test(sha)) return undefined;
  let url = repositoryUrl.trim();
  const ssh = url.match(/^git@([^:]+):(.+)$/);
  if (ssh) url = `https://${ssh[1]}/${ssh[2]}`;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return undefined;
  }
  const path = parsed.pathname.replace(/\.git$/, '').replace(/\/+$/, '');
  if (!path || path === '/') return undefined;
  switch (parsed.hostname.toLowerCase()) {
    case 'github.com':
      return `https://github.com${path}/commit/${sha}`;
    case 'gitlab.com':
      return `https://gitlab.com${path}/-/commit/${sha}`;
    case 'bitbucket.org':
      return `https://bitbucket.org${path}/commits/${sha}`;
  }
  return undefined;
}
